import { downloadCSVFile, getPathAPI } from "@/helpers";
import { AxiosRequestConfig } from "axios";
import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

type IRatingExportPayload = {
  startDate: string;
  endDate: string;
  path: string;
};

class MonthlyRatingsReportService extends BaseCollectionService {
  constructor() {
    super("monthly-ratings-report");
  }
  public async exportMonthlyRatingsReport(
    payload: IRatingExportPayload
  ): Promise<ResponseWrapper> {
    const axiosConfig: AxiosRequestConfig = {
      baseURL: getPathAPI(),
      url: payload.path,
      method: "GET",
      responseType: "blob",
      params: {
        startDate: payload.startDate,
        endDate: payload.endDate
      }
    };

    const response = await this.request(axiosConfig, { useToken: "access" });
    downloadCSVFile(response.data, "MonthlyRatingsReport.csv");

    return response;
  }
}

export default new MonthlyRatingsReportService();
